import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Icon, type IIconsVector, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ManageInfoStore } from './store/manageInfoStore'
import styles from './styles.module.scss'

type IManageInfoLineProps = {
  icon: IIconsVector
  label: string
  count: number
  usedCount: number
  onClick: () => void
}

const ManageInfoLine = ({ icon, label, count, usedCount, onClick }: IManageInfoLineProps) => {
  return (
    <div className={styles.manageInfoLine}>
      <div className={styles.manageInfoLineIconWrap}>
        <Icon icon={icon} fontSize={20} color='var(--content-brand-primary)' />
      </div>
      <div className={styles.manageInfoLineContent}>
        <Typography
          ariaLabel='manage_subscription'
          variant='body-lg-medium'
          className={styles.manageInfoLineLabel}
        >
          {label}
        </Typography>
        <Typography
          ariaLabel='manage_subscription'
          variant='body-md-regular'
          color='var(--content-primary-tertiary)'
        >
          {usedCount} / {count} used
        </Typography>
      </div>

      <Button
        className={styles.manageInfoLineButton}
        text={`Manage ${label.toLowerCase()}`}
        contained='secondary'
        onClick={onClick}
      />
    </div>
  )
}

export const ManageInfo = observer(() => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new ManageInfoStore(entities), [entities])

  const manageInfoLines: IManageInfoLineProps[] = [
    {
      icon: 'phone',
      label: 'Numbers',
      count: store.numbersTotal,
      usedCount: store.numbersUsed,
      onClick: store.onManageNumbersClick,
    },
    {
      icon: 'users',
      label: 'Seats',
      count: store.seatsTotal,
      usedCount: store.seatsUsed,
      onClick: store.onManageSeatsClick,
    },
    {
      icon: 'addOn',
      label: 'Add-ons',
      count: store.addOnsTotal,
      usedCount: store.addOnsActive,
      onClick: store.onManageAddOnsClick,
    },
  ]

  return (
    <div className={styles.manageContainer}>
      {manageInfoLines.map((line) => (
        <ManageInfoLine key={line.label} {...line} />
      ))}
    </div>
  )
})
